<script setup>

import { watch } from 'vue';
const props = defineProps({
  name: {
    type: String,
  },
  variantType: {
    type: String,
  },
  watchlist: {
    type: null,
  },
});

watch(
  () => props.watchlist,
  (newVal) => {
    console.log('watchlist updated:', newVal);
  },
  { deep: true }
)
defineEmits(["onWatchlistUpdate"]);
</script>
<template>
  <td>
    <div class="w-full flex flex-col leading-none items-start" v-if="name">
      <div class="flex flex-col group">
        <p class="text-sm text-theme-secondary cursor-pointer hover:underline" @click="$emit('onProductInfoTrigger')">{{
          name }}</p>
        <!-- <span class="text-xs text-theme-light uppercase flex-shrink-0" v-if="variantType">{{ variantType }}</span> -->
        <button
          class="mt-0.5 flex items-center justify-start cursor-pointer gap-1 text-theme-light hover:text-theme-secondary flex-shrink-0"
          @click="$emit('onWatchlistUpdate')">
          <Icon class="w-2.5 h-2.5" :name="watchlist ? 'heart-outline' : 'heart-filled'" />
          <span class="text-xs flex-shrink-0 ">
            {{ watchlist ? "Remove Favorite" : "Add Favorite" }}
          </span>
        </button>
      </div>
    </div>
  </td>
</template>
